"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-400f8166"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "d-inline-block float-right" };
const _hoisted_2 = { class: "dashboard-btn dropdown dropdown-right" };
const _hoisted_3 = {
    class: "dropdown-toggle footer-btn-toggle summary-btn table-config-btn",
    tabindex: "0"
};
const _hoisted_4 = { class: "flex-column" };
const _hoisted_5 = { class: "menu footer-btn-dropdown table-config-dropdown" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "テーブル構成", -1 /* HOISTED */));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "divider" }, null, -1 /* HOISTED */));
const _hoisted_8 = { class: "accordion" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("input", {
    type: "checkbox",
    id: "accordion-column-width",
    name: "accordion-checkbox",
    hidden: "",
    checked: ""
}, null, -1 /* HOISTED */));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("label", {
    class: "accordion-header table-config-label px-0",
    for: "accordion-column-width"
}, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }),
    /*#__PURE__*/ (0, vue_2.createTextVNode)(" 列の幅 ")
], -1 /* HOISTED */));
const _hoisted_11 = { class: "accordion-body" };
const _hoisted_12 = { class: "table-config-options" };
const _hoisted_13 = ["onClick"];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "divider m-0" }, null, -1 /* HOISTED */));
const vue_3 = require("vue");
const WidthNarrowIcon_vue_1 = __importDefault(require("../../assets/icons/WidthNarrowIcon.vue"));
const WidthMediumIcon_vue_1 = __importDefault(require("../../assets/icons/WidthMediumIcon.vue"));
const WidthWideIcon_vue_1 = __importDefault(require("../../assets/icons/WidthWideIcon.vue"));
const WidthFlexIcon_vue_1 = __importDefault(require("../../assets/icons/WidthFlexIcon.vue"));
const TableConfigIcon_vue_1 = __importDefault(require("../../assets/icons/TableConfigIcon.vue"));
const tableConfig_1 = require("../../../common/tableConfig");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SummaryTableConfig',
    setup(__props) {
        const selectedOption = (0, vue_3.ref)(tableConfig_1.ColumnWidthOptions.FLEX);
        const summaryTableContainer = (0, vue_3.ref)(null);
        const widthOptions = [
            { width: tableConfig_1.ColumnWidthOptions.NARROW, label: '狭い', icon: WidthNarrowIcon_vue_1.default },
            { width: tableConfig_1.ColumnWidthOptions.MEDIUM, label: '中位', icon: WidthMediumIcon_vue_1.default },
            { width: tableConfig_1.ColumnWidthOptions.WIDE, label: '広い', icon: WidthWideIcon_vue_1.default },
            { width: tableConfig_1.ColumnWidthOptions.FLEX, label: 'フレックス', icon: WidthFlexIcon_vue_1.default },
        ];
        function setSummaryTableColumnWidth(option) {
            if (!summaryTableContainer.value) {
                return;
            }
            selectedOption.value = option;
            summaryTableContainer.value.classList.remove(tableConfig_1.ColumnWidthOptions.NARROW, tableConfig_1.ColumnWidthOptions.MEDIUM, tableConfig_1.ColumnWidthOptions.WIDE);
            summaryTableContainer.value.classList.add(option);
            summaryTableContainer.value.classList.toggle('fixed-width', option !== tableConfig_1.ColumnWidthOptions.FLEX);
            window.localStorage.setItem('summaryTableColumnWidth', option);
        }
        function isValidWidthOption(val) {
            return Object.values(tableConfig_1.ColumnWidthOptions).includes(val);
        }
        (0, vue_3.onMounted)(() => {
            summaryTableContainer.value = document.getElementById('summary-table-container');
            const option = window.localStorage.getItem('summaryTableColumnWidth');
            setSummaryTableColumnWidth(isValidWidthOption(option) ? option : tableConfig_1.ColumnWidthOptions.FLEX);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("a", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createVNode)(TableConfigIcon_vue_1.default)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        _hoisted_6,
                        _hoisted_7,
                        (0, vue_2.createCommentVNode)(" Column width "),
                        (0, vue_2.createElementVNode)("div", _hoisted_8, [
                            _hoisted_9,
                            _hoisted_10,
                            (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(widthOptions, (opt) => {
                                        return (0, vue_2.createElementVNode)("div", {
                                            key: opt.width,
                                            class: (0, vue_2.normalizeClass)(["table-config-option", { selected: selectedOption.value === opt.width }]),
                                            onClick: ($event) => (setSummaryTableColumnWidth(opt.width))
                                        }, [
                                            ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)(opt.icon), { class: "table-config-icon" })),
                                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(opt.label), 1 /* TEXT */)
                                        ], 10 /* CLASS, PROPS */, _hoisted_13);
                                    }), 64 /* STABLE_FRAGMENT */))
                                ])
                            ])
                        ]),
                        _hoisted_14
                    ])
                ])
            ]));
        };
    }
});
